import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import pickBy from 'lodash/pickBy';
import Layout from '@/Shared/Layout';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Pagination: Pagination,
    SearchFilter: SearchFilter
  },
  layout: Layout,
  props: {
    filters: Object,
    externalTenantList: Object
  },
  data: function data() {
    return {
      form: {
        search: this.filters.search,
        order_by: this.filters.order_by,
        order: this.filters.order
      },
      tenant_id: "",
      campaignList: [],
      showCampaignList: false
    };
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/external_tenants', pickBy(this.form), {
          preserveState: true
        });
      }, 150)
    }
  },
  methods: {
    reset: function reset() {
      this.form = mapValues(this.form, function () {
        return null;
      });
    },
    getCampaignData: function getCampaignData(tenant_id, tenant_name) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return axios.post('/get_campaign_list', {
                  tenantId: tenant_id
                });
              case 4:
                res = _context.sent;
                if (res.data.status == 'success') {
                  console.log(res.data);
                  _this.tenant_id = tenant_name;
                  _this.campaignList = res.data.campaignList;
                  _this.showCampaignList = true;
                } else {
                  alert(res.data.msg);
                }
                _context.next = 11;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                alert(_context.t0.message);
              case 11:
                _context.prev = 11;
                _this.$store.loading = false;
                return _context.abrupt("return", true);
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8, 11, 15]]);
      }))();
    },
    changeOrder: function changeOrder(field) {
      this.form['order_by'] = field;
      if (this.form['order'] == 'desc') {
        this.form['order'] = 'asc';
      } else {
        this.form['order'] = 'desc';
      }
    }
  }
};